<micro-select-combo #sel
              [placeholder]="placeholder"
              routerBase="contactDepartments"
              [(id)]="contactDepartmentId"
              (idChange)="change($event)"
              [options]="options"
              [jump]="jump"
              [required]="required"
              [disabled]="disabled"
              [requires]="requires()">
</micro-select-combo>
